function isSystemClimateTask(task = {}) {
  return (
    String(task.source || 'manual').toLowerCase() === 'system' &&
    String(task.triggerType || '').toLowerCase() === 'climate_threshold'
  );
}

function cleanDeviceName(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  if (/^unnamed device(?:\s+[\w:-]{8,})?$/i.test(text)) return '';
  return text;
}

function metricLabel(metric) {
  const key = String(metric || '').trim().toLowerCase();
  if (key === 'co2') return 'CO₂';
  if (key === 'humidity') return 'Humidity';
  if (key === 'temperature') return 'Temperature';
  return key ? key.replace(/[_-]/g, ' ') : 'Climate reading';
}

function climateDirection(task = {}) {
  const value = Number(task.triggerValue);
  const min = Number(task.thresholdMin);
  const max = Number(task.thresholdMax);
  if (!Number.isFinite(value)) return '';
  if (Number.isFinite(max) && value > max) return 'above';
  if (Number.isFinite(min) && value < min) return 'below';
  return '';
}

export function getTaskDisplayTitle(task = {}) {
  if (isSystemClimateTask(task)) {
    const metric = String(task.triggerMetric || '').trim().toLowerCase();
    const label = metricLabel(metric);
    const direction = climateDirection(task);
    if (metric === 'temperature' && direction) {
      return `${label} is ${direction} the allowed range`;
    }
    return `${label} is outside the allowed range`;
  }

  return String(task.description || '').replace(/\s+—\s+Unnamed Device\s+[\w:-]{8,}\s*$/i, '').trim();
}

export function getTaskContextParts(task = {}, maps = {}, fallbackFarmName = '') {
  const parts = [];
  const roomId = task.roomId != null && typeof task.roomId === 'object'
    ? String(task.roomId._id || task.roomId.id || '')
    : String(task.roomId || '');
  const deviceId = task.deviceId != null && typeof task.deviceId === 'object'
    ? String(task.deviceId._id || task.deviceId.id || task.deviceId.deviceId || '')
    : String(task.deviceId || '');
  const strainId = task.strainId != null && typeof task.strainId === 'object'
    ? String(task.strainId._id || task.strainId.id || '')
    : String(task.strainId || '');
  const cuttingId = task.cuttingId != null && typeof task.cuttingId === 'object'
    ? String(task.cuttingId._id || task.cuttingId.id || '')
    : String(task.cuttingId || '');

  const roomName =
    task.roomName ||
    task.room?.name ||
    (roomId && maps.rooms?.get?.(roomId)) ||
    '';
  if (roomName) parts.push(String(roomName).trim());

  const deviceName = cleanDeviceName(
    task.deviceName ||
      task.device?.displayName ||
      task.device?.name ||
      (deviceId && maps.devices?.get?.(deviceId))
  );
  if (deviceName) {
    parts.push(deviceName);
  } else if (isSystemClimateTask(task) && (deviceId || task.deviceId)) {
    parts.push('Unknown controller');
  }

  const strainName = task.strainName || task.strain?.name || (strainId && maps.strains?.get?.(strainId));
  if (strainName) parts.push(String(strainName).trim());

  const cuttingName = task.cuttingName || task.cutting?.code || (cuttingId && maps.cuttings?.get?.(cuttingId));
  if (cuttingName) parts.push(String(cuttingName).trim());

  if (!parts.length && task.location) parts.push(String(task.location).trim());
  if (!parts.length && fallbackFarmName) parts.push(String(fallbackFarmName).trim());

  return parts.filter(Boolean);
}

export function getTaskContextDisplay(task = {}, maps = {}, fallbackFarmName = '') {
  return getTaskContextParts(task, maps, fallbackFarmName).join(' · ');
}
